<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { h } from 'vue';
import { useVueTable, getCoreRowModel } from '@tanstack/vue-table';
import Table from 'dashboard/components/table/Table.vue';
const props = defineProps({
  compact: Boolean,
  rows: { type: Array, default: () => [] },
  title: { type: String, default: 'Участники групп за выбранный период' },
});
const count = v =>
  v == null ? 'Нет данных' : Number(v).toLocaleString('ru-RU');
const date = v =>
  v
    ? new Date(v).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' })
    : 'Нет замера';
const delta = v =>
  v == null ? 'Недостаточно замеров' : `${v > 0 ? '+' : ''}${count(v)}`;
const columns = [
  { accessorKey: 'title', header: 'Группа', size: 250 },
  {
    id: 'current',
    header: 'Сейчас',
    cell: ({ row }) =>
      h(
        'span',
        {},
        `${count(row.original.current_count)} · ${date(row.original.current_checked_at)}${row.original.stale ? ' · устарело' : ''}`
      ),
  },
  {
    id: 'period',
    header: 'Замеры периода',
    cell: ({ row }) =>
      `${count(row.original.period_first_count)} → ${count(row.original.period_last_count)}`,
  },
  {
    id: 'delta',
    header: 'Изменение участников',
    cell: ({ row }) =>
      `${delta(row.original.member_delta)} · ${date(row.original.measured_from_at)} — ${date(row.original.measured_to_at)}`,
  },
];
const table = useVueTable({
  get data() {
    return props.rows;
  },
  columns,
  getCoreRowModel: getCoreRowModel(),
  enableSorting: false,
});
</script>

<template>
  <section class="flex flex-col gap-3 min-w-0">
    <h3 class="text-sm font-medium text-n-slate-12 m-0">{{ title }}</h3>
    <p class="text-sm text-n-slate-11 m-0">
      Чистое изменение между доступными замерами: вступления минус выходы. Оно
      не равно выполнению заказа SexySMM. Количество участников обновляется
      штатной проверкой примерно раз в 6 часов.
    </p>
    <div v-if="rows.length && !compact" class="hidden lg:block overflow-x-auto">
      <Table :table="table" fixed type="compact" class="min-w-[750px] w-full" />
    </div>
    <div
      class="grid gap-3"
      :class="compact ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2 lg:hidden'"
    >
      <article
        v-for="row in rows"
        :key="row.id"
        class="p-3 border border-n-weak rounded-xl min-w-0 flex flex-col gap-1"
      >
        <p class="text-sm font-medium text-n-slate-12 m-0 break-words">
          {{ row.title }}
        </p>
        <p class="text-sm text-n-slate-12 m-0">
          Сейчас: {{ count(row.current_count) }} ·
          {{ row.stale ? 'устарело' : 'последний замер' }}
        </p>
        <p class="text-xs text-n-slate-11 m-0">
          {{ date(row.current_checked_at) }} МСК
        </p>
        <p class="text-sm text-n-slate-12 m-0">
          Замеры периода: {{ count(row.period_first_count) }} →
          {{ count(row.period_last_count) }} · изменение:
          {{ delta(row.member_delta) }}
        </p>
        <p class="text-xs text-n-slate-11 m-0">
          {{ date(row.measured_from_at) }} — {{ date(row.measured_to_at) }} МСК
        </p>
      </article>
    </div>
    <p v-if="!rows.length" class="text-sm text-n-slate-11 m-0">
      Групп в этой выборке нет.
    </p>
  </section>
</template>
